import { MoreDotsIcon } from '@tableau/icons/MoreDotsIcon';
import { FlyoutListMenuWidget, MenuButtonWidget, MenuItemInfo } from '@tableau/widgets';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { style } from 'typestyle';

import { Messages } from '~src/codegen/Localize';
import { ToasterService, ToastType } from '~src/commonInfra/services/ToasterService';
import { MapDispatchToProps } from '~src/commonInfra/utils/ConnectUtils';
import { IGetSiteEncryptionKeyHistoryResult } from '~src/kmsInOnline/serverApi/GetSiteEncryptionKeyHistoryRequest';
import { IGetSiteEncryptionKeyResult } from '~src/kmsInOnline/serverApi/GetSiteEncryptionKeyRequest';
import { GetSiteEncryptionKeyHistoryService } from '~src/kmsInOnline/services/GetSiteEncryptionKeyHistoryService';

import { getExtractEncryptionKeyRequest } from '../actions/GetExtractEncryptionKeyRequestAction';
import { openCMEKKeyDeleteKeyDialog } from '../dialogs/CMEKKeyDeleteKeyDialog';


export interface CMEKEncryptionKeyActionMenuState {
    isOpen: boolean;
    isDownloading: boolean;
    isRotating: boolean;
}

export interface CMEKEncryptionKeyActionMenuDispatchProps {
    retrieveExtractEncryptionKey: () => void;
}

export interface CMEKEncryptionKeyActionMenuOwnProps {
    cmekEncrpytionKey: IGetSiteEncryptionKeyResult;
}

export type CMEKEncryptionKeyActionMenuProps = CMEKEncryptionKeyActionMenuOwnProps & CMEKEncryptionKeyActionMenuDispatchProps;

const exploreActionsMenuId = 'actions-menu-explorer-id';

const menuButtonDropdowStyle = style(
    { $nest: { '&&::after': { display: 'none' }, '&:disabled' : {borderColor: 'transparent !important'} } }
);

export const menuButtonStyle: React.CSSProperties = {
    borderColor: 'transparent', padding: 0, minWidth: 30
};

export class CMEKEncryptionKeyActionMenuComponent extends React.Component<CMEKEncryptionKeyActionMenuProps, CMEKEncryptionKeyActionMenuState> {
    private buttonElement: HTMLElement | null = null;

    public constructor(props: CMEKEncryptionKeyActionMenuProps) {
        super(props);

        this.state = {
            isOpen: false,
            isDownloading: false,
            isRotating: false
        };
    }

    private setButtonRef = (ref: HTMLButtonElement | null): void => {
        this.buttonElement = ref;
    };

    private onSelect(label: string) {
        switch (label) {
            case Messages.extractEncryptionTOLKeyHistoryButton():
                this.handleDownload();
              break;
            case Messages.extractEncryptionTOLKeyDeletionDialogConfirmation():
                openCMEKKeyDeleteKeyDialog();
                break;
          }
          this.setState({isOpen: false});
    }

    public render(): JSX.Element {
        return <>
            <MenuButtonWidget
                aria-controls={exploreActionsMenuId}
                isOpen={this.state.isOpen}
                onClick={() => this.setState({ isOpen: !this.state.isOpen })}
                ref={this.setButtonRef}
                testId='cmek-encryption-key-actions-menu'
                density='low'
                className={menuButtonDropdowStyle}
                style={menuButtonStyle}
            >
                <MoreDotsIcon size={14}/>
            </MenuButtonWidget>
            {this.state.isOpen && <FlyoutListMenuWidget
                role='menu'
                anchorEl={this.buttonElement}
                allowAutoPosition
                id={exploreActionsMenuId}
                menuItemInfos={this.getMenuInfoItems()}
                onSelect= {(value: string) => this.onSelect(value)}
                requestCloseAll={() => this.setState({ isOpen: false })}
                testId='cmek-encryption-key-actions-menu-list'
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                toggleEl={this.buttonElement!}
            />}
        </>;
    }

    private getMenuInfoItems(): MenuItemInfo[] {
        return [
            { displayValue: Messages.extractEncryptionTOLKeyHistoryButton(), value: Messages.extractEncryptionTOLKeyHistoryButton() , disabled: this.state.isDownloading },
            { isDivider: true },
            { displayValue: `${Messages.extractEncryptionTOLKeyDeletionDialogConfirmation()}...`, value: Messages.extractEncryptionTOLKeyDeletionDialogConfirmation(), disabled: this.props.cmekEncrpytionKey === undefined || this.props.cmekEncrpytionKey?.errors !== undefined},
        ];
    }

    private handleDownload() {
      this.setState({isDownloading: true}, () => {
      GetSiteEncryptionKeyHistoryService.getSiteEncryptionKeyHistory().then(
        (response: IGetSiteEncryptionKeyHistoryResult) => {
          const url = window.URL.createObjectURL(new Blob([response], { type: response?.type }));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'site_key_history.csv');
          document.body.appendChild(link);
          link.click();
        }).catch(() => {
          ToasterService.instance.pop({ type: ToastType.Error, text: Messages.extractEncryptionTOLKeyHistoryDownloadError() });
      }).finally(() => this.setState({isDownloading: false}));
    });
    }
}

const mapDispatchToProps: MapDispatchToProps<CMEKEncryptionKeyActionMenuDispatchProps> =
  (dispatch) => bindActionCreators({
    retrieveExtractEncryptionKey: getExtractEncryptionKeyRequest
  },
  dispatch);

export const CMEKEncryptionKeyActionMenu: React.ComponentClass<CMEKEncryptionKeyActionMenuOwnProps> =
  connect(undefined, mapDispatchToProps)(CMEKEncryptionKeyActionMenuComponent);